/**
 * Адрес бэка. Кабинет, открытый с другого устройства через nip.io (http://b2b.pride.ru.192.168.2.41.nip.io:3001),
 * ходит на бэк тем же способом: к хосту из REACT_APP_ENDPOINT дописывается «.<ip>.nip.io» —
 * IP машины разработчика не надо прописывать в .env при смене сети.
 */
export function apiEndpoint(endpoint: string = process.env.REACT_APP_ENDPOINT || '', pageHost: string = window.location.hostname): string {
    const ip = pageHost.match(/\.(\d+\.\d+\.\d+\.\d+)\.nip\.io$/)?.[1];
    if (!ip || !endpoint) {
        return endpoint;
    }
    const url = new URL(endpoint);
    url.hostname = url.hostname + '.' + ip + '.nip.io';
    return url.toString().replace(/\/$/, '');
}
